import { InventoryItemWithPricing, LineItemMatchesInventoryItem } from '@galaxy/inventory-ui';
import { getPriceValueForEdition, setInstanceAppPrice } from '@vendasta/billing-ui';
import { Cost, LineItem, Order } from '@vendasta/sales-orders';
import { convertCentsToDollars } from '@vendasta/shared';
import { OrderConfirmationItem } from '../confirmation-page/interface';

export const CENTS_DOLLAR = 100;
export function getInitInputValue(order: Order, orderItem: OrderConfirmationItem): number {
  const appId = orderItem.addonId ? orderItem.addonId : orderItem.appId;
  let formFieldValue = convertCentsToDollars(
    getPriceValueForEdition(
      orderItem?.appPrices.pricesForContexts['wholesale'],
      orderItem?.partnerCurrency,
      orderItem?.editionId || '',
      true,
    ) || 0,
  );
  order.lineItems.forEach((lineItem) => {
    if (
      lineItem?.appKey?.appId === appId &&
      lineItem?.appKey?.editionId === orderItem.editionId &&
      lineItem?.cost?.customPrice
    ) {
      formFieldValue = lineItem.cost.customPrice / CENTS_DOLLAR;
    }
  });
  return formFieldValue;
}

export function updateOrderCustomPrice(newValue: number, order: Order, orderItem: OrderConfirmationItem): void {
  order.lineItems.forEach((lineItem, i) => {
    if (matchLineItemWithOrderItem(lineItem, orderItem)) {
      lineItem.cost = new Cost({ customPrice: Math.round(Number(newValue) * CENTS_DOLLAR) });
      order.lineItems[i] = lineItem;
      let appPrice = orderItem.appPrices.pricesForContexts['wholesale'];
      appPrice = setInstanceAppPrice(
        appPrice,
        orderItem.partnerCurrency,
        newValue * CENTS_DOLLAR,
        orderItem.editionId || '',
      );
      orderItem.effectiveAppPrice = appPrice;
    }
  });
}

export function updateOrderCustomPriceFromItem(order: Order, orderItem: OrderConfirmationItem): void {
  order.lineItems.forEach((lineItem, i) => {
    if (matchLineItemWithOrderItem(lineItem, orderItem)) {
      lineItem.cost = new Cost({
        customPrice: getPriceValueForEdition(
          orderItem.effectiveAppPrice || orderItem.appPrices.pricesForContexts['wholesale'],
          orderItem.partnerCurrency,
          orderItem.editionId || '',
          true,
        ),
      });
      order.lineItems[i] = lineItem;
    }
  });
}

export function updateOrderItemsWithCustomPrice(
  orderItems: OrderConfirmationItem[],
  order: Order,
): OrderConfirmationItem[] {
  order?.lineItems?.forEach((lineItem) => {
    for (let i = 0; i < orderItems?.length; i++) {
      let appPrice = orderItems[i].appPrices.pricesForContexts['wholesale'];
      if (matchLineItemWithOrderItem(lineItem, orderItems[i]) && lineItem?.cost?.customPrice) {
        appPrice = setInstanceAppPrice(
          appPrice,
          orderItems[i].partnerCurrency,
          lineItem?.cost?.customPrice,
          orderItems[i].editionId || '',
        );
        orderItems[i].effectiveAppPrice = appPrice;
      }
    }
  });
  return orderItems;
}

export function updatePricingTableItemsWithCustomPrice(
  items: InventoryItemWithPricing[],
  order: Order,
): InventoryItemWithPricing[] {
  order?.lineItems?.forEach((lineItem) => {
    for (let i = 0; i < items?.length; i++) {
      if (LineItemMatchesInventoryItem(lineItem, items[i])) {
        items[i].pricing = lineItem;
      }
    }
  });
  return items;
}

export function matchLineItemWithOrderItem(lineItem: LineItem, orderItem: OrderConfirmationItem): boolean {
  const appId = orderItem?.addonId || orderItem?.appId || '';
  const editionId = orderItem?.editionId || '';
  const lineItemAppId = lineItem?.appKey?.appId || '';
  const lineItemEditionId = lineItem?.appKey?.editionId || '';
  return lineItemAppId === appId && lineItemEditionId === editionId;
}
